module.exports = __webpack_public_path__ + "static/img/04.ec65449.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/04.jpg
// module id = bXbr
// module chunks = 0